var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVlaraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 440.9 290.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.9,215.6l-20.1,32.6-4.1,6.7-2.3,3.7c-12,19.5-36.9,31.9-64.2,31.9h-164.2c-15.8,0-30.8-3.9-43.2-10.8-12.4-6.9-22.2-16.7-27.6-28.6l-31.9-69.5-6.3-13.9L31.2,68.1l-3.5-7.7L0,0h65.8c1.5,0,2.9,0,4.4.2,2.6.2,5.1.6,7.6,1.1,14.7,3.1,26.9,11.9,32,23.7l12.1,28,3,6.9,36.5,84.4h0l4.6,10.6h0l21.3,49.1,73.7-170.3,3.8-8.7h0C271.3,10,289,0,308.8,0h63.2l-.4,1-27.5,60.1-3.1,6.7-67.8,147.9h167.8,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlaraLogo);
export default __webpack_public_path__ + "static/media/vlara-logo.b4c2c23040d0ec5aad7adb44a534284a.svg";
export { ForwardRef as ReactComponent };